import React from "react";
import { TextField, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  TIME_FILTERS_SAME_DATE_TOOLTIP,
  timeFiltersSameDateTooltipProps,
} from "../../common/timeFiltersSameDateTooltip";

export const StartTimeDropDownSentinel = ({
  userFiltersSentinel,
  setUserFiltersSentinel,
  timeFiltersDisabledSentinel,
  showUserDropDownSentinel,
}: {
  userFiltersSentinel: any;
  setUserFiltersSentinel: Dispatcher<any>;
  timeFiltersDisabledSentinel: boolean;
  showUserDropDownSentinel: boolean;
}) => {
  const sx = showUserDropDownSentinel ? { width: 132 } : { width: 135 };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Tooltip
        title={TIME_FILTERS_SAME_DATE_TOOLTIP}
        disableHoverListener={!timeFiltersDisabledSentinel}
        disableFocusListener={!timeFiltersDisabledSentinel}
        disableTouchListener={!timeFiltersDisabledSentinel}
        {...timeFiltersSameDateTooltipProps}
      >
        <span style={{ display: "inline-block" }}>
          <DesktopTimePicker
            label="Start Time"
            value={
              userFiltersSentinel.start_time
                ? userFiltersSentinel.start_time
                : null
            }
            onChange={(newValue) => {
              setUserFiltersSentinel((previousState: any) => {
                return { ...previousState, start_time: newValue };
              });
            }}
            disabled={timeFiltersDisabledSentinel}
            renderInput={(params) => (
              <TextField {...params} autoComplete="off" sx={sx} />
            )}
          />
        </span>
      </Tooltip>
    </LocalizationProvider>
  );
};
